const PRODUCT_OWN_BRAND_NAMES = ['beavita', 'nu3', 'redcare', 'skintist']

/**
 * Identifies supported own-brand names in product brand labels.
 */
export const productIsOwnBrand = (brandName: string): boolean => {
  const normalizedBrand = brandName.toLowerCase()

  return PRODUCT_OWN_BRAND_NAMES.some((ownBrandName) =>
    normalizedBrand.includes(ownBrandName),
  )
}
